import {
    Utensils, ShoppingBag, Plane, Ticket, Car, Wrench, Dumbbell, Gift,
} from "lucide-react";

export const CATEGORY_ICONS = {
    restaurants: Utensils,
    retail: ShoppingBag,
    travel: Plane,
    entertainment: Ticket,
    auto: Car,
    home: Wrench,
    fitness: Dumbbell,
    freebies: Gift,
};

export const CATEGORY_LABELS = {
    restaurants: "Restaurants",
    retail: "Retail",
    travel: "Travel & Hotels",
    entertainment: "Entertainment",
    auto: "Auto",
    home: "Home Services",
    fitness: "Gyms & Fitness",
    freebies: "Freebies & Holidays",
};

export const CATEGORY_LIST = [
    { slug: "restaurants", label: "Restaurants" },
    { slug: "retail", label: "Retail" },
    { slug: "travel", label: "Travel & Hotels" },
    { slug: "entertainment", label: "Entertainment" },
    { slug: "auto", label: "Auto" },
    { slug: "home", label: "Home Services" },
    { slug: "fitness", label: "Gyms & Fitness" },
    { slug: "freebies", label: "Freebies & Holidays" },
];

export const US_STATES = [
    "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS",
    "KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY",
    "NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
];

export const BRANCHES = [
    "Army", "Navy", "Marines", "Air Force", "Space Force", "Coast Guard", "Veterans", "Active", "Retired",
];
